import React from "react";

function ClipIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
    >
      <g id="Clip_Icon" data-name="Clip Icon" transform="translate(0 0.294)">
        <circle
          id="Ellipse_2337"
          data-name="Ellipse 2337"
          cx="24"
          cy="24"
          r="24"
          transform="translate(0 -0.294)"
          opacity="0.7"
        />
        <path
          id="Clip_Icon-2"
          data-name="Clip Icon"
          d="M10.452,8.115,13,10.663l7.012-7.012a2.2,2.2,0,0,1,3.111,0l.778.778L10.452,17.878a4.4,4.4,0,1,1-2.333-2.334L10.667,13,8.118,10.449a4.4,4.4,0,1,1,2.333-2.333ZM6.4,8.6A2.2,2.2,0,1,0,4.2,6.4,2.2,2.2,0,0,0,6.4,8.6Zm0,13.2a2.2,2.2,0,1,0-2.2-2.2A2.2,2.2,0,0,0,6.4,21.8Zm10.488-7.245L23.9,21.564l-.778.778a2.2,2.2,0,0,1-3.111,0l-5.457-5.457Z"
          transform="translate(11.05 10.709)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default ClipIcon;
